import { API_URL } from '../../../app-config/constants';
import type { MeetingAction, MeetingActionCreate, MeetingActionUpdate } from '../../../types/MeetingAction';
import { get, patch, post, remove } from '../request';

const ENTRY = `${API_URL}/meeting-actions`;

getMeetingActions.operation = 'READ';
export function getMeetingActions(participantIds: [string, string]) {
    return get<MeetingAction[]>(`${ENTRY}`, { getData: { participants: participantIds.join(',') } });
}

getUncheckedMeetingActions.operation = 'READ';
export function getUncheckedMeetingActions(forUserId: string) {
    return get<MeetingAction[]>(`${ENTRY}`, { getData: { forUser: forUserId } });
}

create.invalidates = ['getMeetingActions', 'getUncheckedMeetingActions'];
export function create(meetingActionCreate: MeetingActionCreate) {
    return post<MeetingAction>(`${ENTRY}`, { postData: meetingActionCreate });
}

update.operation = 'COMMAND';
update.invalidates = ['getUncheckedMeetingActions'];
export function update(meetingActionUpdate: MeetingActionUpdate) {
    return patch<MeetingAction>(`${ENTRY}`, { postData: meetingActionUpdate });
}

deleteAction.operation = 'DELETE';
deleteAction.invalidates = ['getUncheckedMeetingActions'];
export function deleteAction(action: MeetingAction) {
    return remove<void>(`${ENTRY}/${action.id}`);
}
